//angular imports
import {
    ChangeDetectionStrategy,
    Component, 
    WritableSignal, 
    signal,
} from '@angular/core';

//local imports
import { PresenterType } from '@shared/components';
import { CategoryUpdatedMessage } from './category-updated.message';

@PresenterType(
{
    model: CategoryUpdatedMessage
})
@Component({
    selector: 'category-updated-message-template',
    templateUrl: './category-updated-message-template.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CategoryUpdatedMessageTemplateComponent
{
    public data: WritableSignal<CategoryUpdatedMessage>;
    
    constructor() {
        this.data = signal<CategoryUpdatedMessage>(null);
    }
}